import { Form } from 'antd/lib/form'
import { Select } from 'antd/lib/select'
import List from '../../../components/Operations/TaskSystem/List'
import TaskSystemBoard from '../../../components/Operations/TaskSystem/TaskSystemBoard'
import { Button, Card, Col, Layout, Row } from 'antd'
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

const { Content } = Layout

function TaskSystem (props) {
  const { listView, fetch, changeView } = props

  return (
    <div className="w-full">
      <Row>
        <Col style={{ paddingTop: '1%' }} span={24}>
          <div style={{ marginRight: 20, float: 'right' }}>
            {listView && (
              <Button
                type={'dashed'}
                icon={listView ? 'appstore' : 'bars'}
                onClick={() => {
                  changeView()
                  fetch()
                }}
                style={{
                  marginLeft: 5,
                  marginRight: 5,
                  marginBottom: 0,
                  float: 'right',
                }}>
                View
              </Button>
            )}
          </div>
        </Col>
      </Row>

      <Row gutter={16} style={{ padding: 10 }}>
        {listView ? (
          <Card>
            <List {...props} />
          </Card>
        ) : (
          <TaskSystemBoard {...props} />
        )}
      </Row>
    </div>
  )
}

TaskSystem.propTypes = {}
TaskSystem.defaultProps = {}

export default withRouter(TaskSystem)
